import { ReactNode } from 'react';
import { AppShellErrorBoundary } from './AppShellErrorBoundary';
import { AppStatusGate } from './AppStatusGate';

type AppHealthGateProps = {
  children: ReactNode;
};

export function AppHealthGate({ children }: AppHealthGateProps) {
  return (
    <AppStatusGate>
      <AppShellErrorBoundary>{children}</AppShellErrorBoundary>
    </AppStatusGate>
  );
}
